import loadImage from 'blueimp-load-image'

export const resizeImageBeforeUpload = (blob, width, height) => {
  return blobToBase64(blob).then((base64) => {
    return resizeImage(base64, width, height).then((resized) =>
      blobToFile(dataURItoBlob(resized), {
        name: blob.name,
        lastModifiedDate: new Date(),
      }),
    )
  })
}

export const dataURItoBlob = (
  dataURI,
  mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0],
) => {
  var byteString = atob(dataURI.split(',')[1])

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length)

  // create a view into the buffer
  var ia = new Uint8Array(ab)

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString })

  return blob
}

export const resizeImage = (base64, maxWidth = 800, maxHeight = 800) => {
  return new Promise((res, rej) => {
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    var canvasCopy = document.createElement('canvas')
    var copyContext = canvasCopy.getContext('2d')

    var img = new Image()
    img.src = base64

    img.onload = function () {
      var ratio = 1
      if (img.width > maxWidth) ratio = maxWidth / img.width
      else if (img.height > maxHeight) ratio = maxHeight / img.height
      canvasCopy.width = img.width
      canvasCopy.height = img.height
      copyContext.drawImage(img, 0, 0)

      canvas.width = img.width * ratio
      canvas.height = img.height * ratio

      ctx.drawImage(
        canvasCopy,
        0,
        0,
        canvasCopy.width,
        canvasCopy.height,
        0,
        0,
        canvas.width,
        canvas.height,
      )

      res(canvas.toDataURL())
    }
  })
}

export const blobToBase64 = (blob) =>
  new Promise((res, rej) => {
    const reader = new window.FileReader()
    reader.readAsDataURL(blob)
    reader.onloadend = function () {
      const base64data = reader.result
      if (base64data) {
        res(base64data)
      }
    }
  })

export function blobToFile(theBlob, image) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = image.name
  theBlob.preview = image.preview
  return theBlob
}

export function removeExif(image) {
  return new Promise((res, rej) => {
    loadImage(
      image,
      (img) => {
        if (img.type === 'error') {
          return rej('error loading image')
        }

        img.toBlob((blob) => {
          const file = blobToFile(blob, image)

          return res(file)
        })
      },
      {
        canvas: true,
        orientation: true,
      },
    )
  })
}

export const getAssetType = (name) => {
  return /\.pdf$/i.test(name) || /(\.csv)$/i.test(name) ? 'document' : 'photo'
}



// WEBPACK FOOTER //
// ./src/utils/Image.js